import styled from 'styled-components';
import { WithDirection } from '@jjj/components';
import { palette } from 'styled-theme';

const Wrapper = styled.div`
  .back-to-login-link {
    font-weight: 400;
    font-size: 13px;
    line-height: 18px;
    letter-spacing: 0px;
    text-align: center;
    text-decoration: underline;
    text-align: center;
    display: flex;
    width: 100%;
    margin: 16px auto;
    text-decoration-color: ${palette('primary', 0)};

    span {
      font-weight: 400;
      color: ${palette('primary', 0)};
    }
  }
`;

export default WithDirection(Wrapper);
